import { useState, type FormEvent } from 'react';
import { supabase } from '../lib/supabase';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<{ kind: 'ok' | 'error'; text: string } | null>(null);

  const withPassword = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setMsg(null);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setMsg({ kind: 'error', text: error.message === 'Invalid login credentials'
      ? 'Email or password not recognised. First time here? Use “Email me a sign-in link” below.'
      : error.message });
    setBusy(false);
  };

  const withLink = async () => {
    if (!email) return setMsg({ kind: 'error', text: 'Enter your email first.' });
    setBusy(true);
    setMsg(null);
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: { emailRedirectTo: `${window.location.origin}/account` },
    });
    setMsg(error ? { kind: 'error', text: error.message } : { kind: 'ok', text: `Check ${email} for a sign-in link.` });
    setBusy(false);
  };

  return (
    <div className="login">
      <form className="card stack" onSubmit={withPassword}>
        <div>
          <h1>Simply Totes</h1>
          <div className="muted">Quotes, jobs and customers</div>
        </div>
        <label className="field">
          <span>Email</span>
          <input type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </label>
        <label className="field">
          <span>Password</span>
          <input type="password" autoComplete="current-password" value={password}
            onChange={(e) => setPassword(e.target.value)} />
        </label>
        {msg && <div className={msg.kind}>{msg.text}</div>}
        <button className="primary" disabled={busy || !password} type="submit" style={{ width: '100%', justifyContent: 'center' }}>
          Sign in
        </button>
        <button type="button" disabled={busy} onClick={withLink} style={{ width: '100%', justifyContent: 'center' }}>
          Email me a sign-in link
        </button>
        <p className="muted small" style={{ margin: 0 }}>
          First time? Use the sign-in link, then set a password on the Account page.
        </p>
      </form>
    </div>
  );
}
